import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { FieldStateV3, FormContext } from '../../../../commonv3/states/form/FormStateV3';
import { SubmissionFieldType } from '../../../../commonv3/types/course_works';
import { SubmittedField } from '../../../../commonv3/types/lesson_homeworks';
import { UploadedFilePreview } from '../userFiles/UploadedFilePreview';
import Linkify from 'linkifyjs/react';
import './submittedReviewFields.module.scss';
import { ISODateTime } from '../../../../admin/types/date';
import { DetailedDateTime } from '@sheinc/design-system';

const FieldSummary = ({ field }: { field: SubmittedField }) => {
    const [state] = useState(new FieldStateV3<any>());
    useEffect(
        () => {
            state._init(field.definition.uid, new FormContext(), field.value);
        },
        [field]
    );
    switch (field.definition.type) {
        case SubmissionFieldType.FILE:
            return <UploadedFilePreview value={field.value as string[]} />;
        case SubmissionFieldType.SINGLE_LINE_TEXT:
            return (
                <div>
                    <Linkify options={{ className: 'submission-single-line-link' }}>{field.value} </Linkify>
                </div>
            );
        case SubmissionFieldType.GOOGLE_URL:
            return (
                <div id="google-url-preview">
                    <Linkify options={{ className: 'google-url-link' }}>{field.value} </Linkify>
                </div>
            );
        case SubmissionFieldType.MULTI_LINE_TEXT:
            return (
                <div>
                    <pre styleName="submission-multi-line">{field.value}</pre>
                </div>
            );
    }
};

const FieldSummaryWrapper = ({ field }: { field: SubmittedField }) => {
    return (
        <div data-wrapper="review-field-wrapper" data-field-uid={field.definition.uid}>
            <div styleName="review-field-label">{field.definition.label}</div>
            <div styleName="review-field">
                <FieldSummary field={field} />
            </div>
        </div>
    );
};

type Props = {
    submittedReviewFields: SubmittedField[];
    review_completed_at: ISODateTime | null;
};
export const SubmittedReviewFields = observer(({ submittedReviewFields, review_completed_at }: Props) => {
    return (
        <div styleName="review-field-wrapper">
            {submittedReviewFields.map((field) => <FieldSummaryWrapper key={field.definition.uid} field={field} />)}
            <div styleName="review_completed_at">
                <DetailedDateTime date={review_completed_at} />
            </div>
        </div>
    );
});
